import { IconComponentsProps } from './types';

const DashboardIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9 21H7.5V17.5605L2.56055 22.5L1.5 21.4395L6.43945 16.5H3V15H9V21ZM21 1.5C21.3977 1.50046 21.7793 1.65825 22.0605 1.93945C22.3418 2.22066 22.4995 2.60232 22.5 3V21C22.4995 21.3977 22.3417 21.7794 22.0605 22.0605C21.7794 22.3417 21.3977 22.4995 21 22.5H12V21H21.002L21.001 9.75H3V12H1.5V3C1.5004 2.6023 1.65823 2.22067 1.93945 1.93945C2.22067 1.65823 2.6023 1.5004 3 1.5H21ZM13.5 19.5H12V13.5H13.5V19.5ZM16.5 19.5H15V12H16.5V19.5ZM19.5 19.5H18V15.75H19.5V19.5ZM3 3V8.25H9V3H3ZM10.5 3V8.25H21.001L21 3H10.5Z"
      fill={fill}
    />
  </svg>
);

export default DashboardIcon;
